import { useStoreState } from "pullstate";
import React, { SetStateAction } from "react";
import "../../Trade/index.css";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { Token } from "../../../store/global/TokenEnum";
import { Balance } from "../../../store/global/getBalances";
import { Amount } from "../../../types/amount";
import { isWrappingQuantityLargerThanBalance } from "../../../utils/wrapUtils";
import { CurrencyInput } from "../../../components/general/CurrencyInput/CurrencyInput";

export interface AmountInputProps {
  visible?: boolean;
  maxAmount?: Balance;
  wrapQuoteAmount: Amount | undefined;
  handleInput: (value: Amount, isMax: boolean) => void;
  symbol: Token;
  setIsMax?: React.Dispatch<SetStateAction<boolean>>;
}

export const WrapAmountInput: React.FC<AmountInputProps> = props => {
  const state = useStoreState(GlobalStore);

  if (!props.visible) {
    return null;
  }
  const value = props.wrapQuoteAmount ?? Amount.ZERO;
  return (
    <div className="input-w-button">
      <CurrencyInput
        value={value}
        onValueChange={value => {
          if (value) {
            props.handleInput(value, false);
          }
        }}
        symbol={props.symbol}
        classNames={{
          "amt-input-form symbol": true,
          error: isWrappingQuantityLargerThanBalance(state) ?? false,
        }}
        maxButton={{ symbol: props.symbol }}
        setIsMax={props.setIsMax}
        id="o2o-top"
        data-testid={`${props.symbol}-amount-input`}
      />
    </div>
  );
};
